function homeSlider() {
  $('.site-home-slider .swiper-wrapper').slick({
    autoplay: true,
    autoplaySpeed: 2500,
    lazyIndicator: 'custom-loading.gif',
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          adaptiveHeight: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: false,
          variableWidth: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          adaptiveHeight: false,
          variableWidth: false
        }
      },
      {
        breakpoint: 320,
        settings: {
          adaptiveHeight: false,
          variableWidth: false
        }
      }
    ]
  })
}
export { homeSlider }
